var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlansDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M655 2550 l-309 -5 -168 -299 c-92 -165 -168 -302 -168 -305 1 -3 79 -136 173 -296 l173 -290 349 -3 350 -2 168 298 c92 164 167 304 167 310 0 6 -78 143 -173 304 l-174 293 -39 0 c-21 1 -178 -2 -349 -5z m475 -331 c78 -132 144 -248 146 -257 2 -10 -59 -127 -135 -262 l-139 -245 -288 -8 c-230 -6 -290 -5 -299 5 -21 22 -295 490 -292 497 2 3 66 117 142 253 l138 247 121 4 c67 1 198 4 292 5 l172 2 142 -241z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593 1893 l-91 -4 -166 -294 c-91 -162 -166 -300 -166 -307 0 -6 78 -144 173 -305 l172 -294 350 6 c192 4 350 7 351 8 38 66 334 597 334 600 0 3 -78 137 -174 298 l-174 294 -259 1 c-142 0 -299 -2 -350 -3z m700 -342 l148 -249 -143 -253 -143 -254 -294 0 -293 0 -144 243 c-79 133 -144 246 -144 251 0 5 63 122 141 260 l141 251 292 0 292 0 147 -249z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 906 l-171 -304 176 -298 177 -298 344 3 c190 1 348 6 352 9 18 18 338 598 334 607 -2 6 -80 138 -173 295 l-169 285 -350 3 -349 2 -171 -304z m958 -40 l148 -249 -26 -46 c-14 -25 -77 -139 -141 -252 l-115 -206 -181 -6 c-99 -4 -231 -7 -292 -7 l-113 0 -146 246 c-80 136 -146 252 -146 258 0 6 63 121 139 256 l138 245 179 5 c98 4 231 6 294 5 l114 0 148 -249z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansDark);
export default __webpack_public_path__ + "static/media/plansDark.aac4194572f1fa6c472820ad6441e736.svg";
export { ForwardRef as ReactComponent };